/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const challengeTranslationSchema = z.object({
  id: z.number(),
  challengeId: z.number(),
  lang: z.string(),
  title: z.string().nullable(),
  definition: z.string(),
  definitionSimple: z.string().nullable(),
  usageNotes: z.string().nullable(),
  examples: z.string().nullable(),
  verified: z.number(),
  generatedAt: z.string().nullable(),
});

export type IChallengeTranslation = z.infer<typeof challengeTranslationSchema>;
